
import Swipe from 'components/mixins/Swipe.vue'

import { mapGetters } from 'vuex'

export default {
  props: ['data','index','sharedData'],
  mixins: [
    Swipe,
  ],
  data() {
    return {
      currentSubSection: 0
    }
  },
  computed: {
    ...mapGetters([
      'currentSection'
    ]),
    subSections() {
      return this.data.sections;
    }
  },
  methods: {
    // gradient(index, key) {
    //   const gradient = this.subSections[index].sectionPickerGradient;

    //   if(!gradient && !gradient[key])
    //     return this[key];

    //   return gradient[key];
    // },
    nextSubSection() {
      const nextIndex = this.currentSubSection + 1;
      if(nextIndex > this.subSections.length-1) return;
      this.currentSubSection = nextIndex;
    },
    prevSubSection() {
      const prevIndex = this.currentSubSection - 1;
      if(prevIndex < 0) return;
      this.currentSubSection = prevIndex;
    }
  },
  mounted() {
    this.trackSwipe(this.$el, 'x', this.nextSubSection, this.prevSubSection)

    const leftAndRight = (e) => {
      if(this.currentSection !== this.index)
        return;

      if(e.keyCode === 39) this.nextSubSection();
      if(e.keyCode === 37) this.prevSubSection();
    }

    document.addEventListener('keydown', leftAndRight);
  }
}



// WEBPACK FOOTER //
// ./components/mixins/SubSections.vue